// @core/api/endpoints/secret/put_kv_secret.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KvSecretResponse,
  PutKvSecretRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Write KV secret
 * Creates or updates a KV secret at the specified path. Each write creates a new version. Supports Check-And-Set (CAS) via the cas field — set to the current version to prevent concurrent writes.
 */
export async function PutKvSecret(
  engine_id: string,
  path: string,
  data: PutKvSecretRequest,
  options?: RequestOptions
): Promise<KvSecretResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/data/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.post<KvSecretResponse>(requestPath, data, requestOptions);
}
